<div #mainDiv_ll_model_cash_upload>
  <div *ngIf="bundle.showThis; then MAPPING; else BLANK"></div>
  <ng-template #BLANK></ng-template>
  <ng-template #MAPPING>
    <div [style.top.px]="10"
         [style.left.px]="0"
         [style.width.px]="bundle.parentW"
         [style.height.px]="bundle.parentH"
         style="position:absolute; z-index:100; overflow:visible;">

      <!-- UPLOAD BUTTON -->
      <div [style.top.px]="10" [style.left.px]="bundle.fileBoxX" style="position:absolute;">
        <div *ngIf="bundle.canUpload" class="upload-btn-wrapper"
             [style.top.px]="0" [style.left.px]="bundle.fileBoxX + 30"
             style="display:inline-block; margin-left:15px;">
          <button class="btn"><img height="20" src="assets/icon_upload.png"></button>
          <input type="file" (change)="fileUpload($event)" accept="{{bundle.acceptedExts}}">
          <div class="wordBtn" style="width:70px;">Upload New</div>
        </div>
      </div>

      <!-- DOCUMENT LIST -->
      <div #scrollBox
           [style.top.px]="bundle.fileBoxY + 40"
           [style.left.px]="bundle.fileBoxX"
           [style.width.px]="bundle.fileBoxW"
           [style.height.px]="bundle.fileBoxH"
           style="position:absolute; border:1px solid #ccc; overflow-y:auto; background:white;">
        <div *ngFor="let doc of bundle.documents; let i = index"
             [ngClass]="{'selected-row': i === bundle.docIndex}"
             (click)="selectDocument(i)"
             style="padding:4px 8px; cursor:pointer; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
          {{ doc.FILENAME }}
        </div>
      </div>

      <!-- SAMPLE TABLE (DROP ZONE) -->
      <div class="sampleGrid"
           [style.top.px]="bundle.sampleGridY"
           [style.left.px]="bundle.gridX"
           [style.width.px]="bundle.gridW"
           [style.height.px]="bundle.sampleGridH"
           style="position:absolute; border:1px solid #ddd; background:white; overflow:visible; min-height:200px; min-width:400px; display:flex; flex-direction:column;">
        <div *ngIf="bundle.sampleDataReady; else LOADING" style="flex:1; overflow:auto;">
          <table style="min-width:100%; border-collapse:collapse; table-layout:fixed; width:100%;">
            <colgroup>
              <col *ngFor="let col of bundle.columns" [style.width.px]="col.studyColumnWidth" />
            </colgroup>
            <thead>
              <tr style="position:sticky; top:0; z-index:10;">
                <th *ngFor="let col of bundle.columns"
                    [style.background]="hoveredColumn === col.STUDYCOLUMNQUESTIONIDALPHA ? '#e3f2fd' : ''"
                    style="border:1px solid #ccc; padding:8px; text-align:left; font-weight:600; position:relative; box-sizing:border-box;"
                    (mouseenter)="setColumnHover(col.STUDYCOLUMNQUESTIONIDALPHA, true)"
                    (mouseleave)="setColumnHover(null, true)">
                  <div style="white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                    {{ col.studyColumnLabel }}
                  </div>
                  <div *ngIf="col.studyColumnDescription"
                       style="position:absolute; top:2px; right:2px; width:16px; height:16px; cursor:pointer; z-index:11;"
                       (mouseenter)="showColumnTooltip($event, col.STUDYCOLUMNQUESTIONIDALPHA)"
                       (mouseleave)="hideColumnTooltip(col.STUDYCOLUMNQUESTIONIDALPHA)">
                    <img height="10" src="assets/infoBtn.png" alt="Info">
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of bundle.sampleData">
                <td *ngFor="let col of bundle.columns"
                    [style.background]="hoveredColumn === col.STUDYCOLUMNQUESTIONIDALPHA ? '#e3f2fd' : ''"
                    style="border:1px solid #eee; padding:6px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; box-sizing:border-box;"
                    (mouseenter)="setColumnHover(col.STUDYCOLUMNQUESTIONIDALPHA, true)"
                    (mouseleave)="setColumnHover(null, true)">
                  {{ row[col.STUDYCOLUMNQUESTIONIDALPHA] ?? '' }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <ng-template #LOADING>
          <div style="display:flex; align-items:center; justify-content:center; height:100%; color:#666;">
            Loading sample data...
          </div>
        </ng-template>
      </div>

      <!-- MAPPING TABLE -->
      <div class="mappingGrid"
           [style.top.px]="bundle.gridY"
           [style.left.px]="bundle.gridX"
           [style.width.px]="bundle.gridW"
           [style.height.px]="bundle.gridH"
           style="position:absolute; border:1px solid #aaa; background:white; overflow:visible; box-shadow:0 2px 6px rgba(0,0,0,0.1); display:flex; flex-direction:column;">
        <div *ngIf="bundle.uploadDataReady; else MAPPING_LOADING" style="flex:1; overflow:auto;">
          <div *ngIf="bundle.mappingHeaders.length > 0; else NO_MAPPING">
            <table style="min-width:100%; border-collapse:collapse; table-layout:fixed; width:100%;">
              <colgroup>
                <col *ngFor="let header of bundle.mappingHeaders; let i = index"
                     [style.width.px]="getMappingColumnWidth(i)" />
              </colgroup>
              <thead>
                <tr style="background:white; position:sticky; top:0; z-index:10;">
                  <th *ngFor="let header of bundle.mappingHeaders; let i = index"
                      [style.background]="hoveredMappingHeader === header ? '#bbdefb' : ''"
                      [class.draggable]="!isStudyColumn(header)"
                      style="border:1px solid #ccc; padding:8px; text-align:left; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; box-sizing:border-box;"
                      (mousedown)="!isStudyColumn(header) && startDrag($event, header)"
                      (touchstart)="!isStudyColumn(header) && startDrag($event, header)">
                    {{ header }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of bundle.uploadedFile">
                  <td *ngFor="let header of bundle.mappingHeaders; let i = index"
                      style="border:1px solid #ddd; padding:6px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; box-sizing:border-box;">
                    {{ getHeaderValue(header, row) || '—' }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <ng-template #NO_MAPPING>
            <div style="padding:20px; text-align:center; color:#777; font-style:italic;">
              No columns to display.
            </div>
          </ng-template>
        </div>
        <ng-template #MAPPING_LOADING>
          <div style="display:flex; align-items:center; justify-content:center; height:100px; color:#666;">
            Loading mapping...
          </div>
        </ng-template>
      </div>

      <!-- TOOLTIP RENDERER (FLOATING) -->
      <div *ngFor="let col of bundle.columns"
           [style.position]="'fixed'"
           [style.left.px]="tooltipState[col.STUDYCOLUMNQUESTIONIDALPHA]?.x"
           [style.top.px]="tooltipState[col.STUDYCOLUMNQUESTIONIDALPHA]?.y"
           [style.display]="tooltipState[col.STUDYCOLUMNQUESTIONIDALPHA]?.visible ? 'block' : 'none'"
           [style.z-index]="9999"
           [style.pointer-events]="'none'"
           style="background:#f5f5f5; color:black; padding:10px 14px; border-radius:8px; font-size:12px; max-width:320px; box-shadow:0 6px 16px rgba(0,0,0,0.4); white-space:normal; line-height:1.5; font-family:Arial, sans-serif; transform:translate(-100%, -50%);">
        <div style="position:relative;">
          {{ col.studyColumnDescription }}
          <div style="position:absolute; right:-8px; top:50%; transform:translateY(-50%) rotate(45deg); width:12px; height:12px; background:#f5f5f5;"></div>
        </div>
      </div>

    </div>

    <div *ngIf="bundle.canDelete"
         class="wordBtn14"
         (click)="deleteFile()"
         [style.top.px]="bundle.gridY + bundle.gridH + 20"
         [style.left.px]="bundle.gridX + bundle.gridW - 500"
         [style.width.px]="100"
         style="position: absolute; text-align: center;">
      <span>Delete Upload </span>
    </div>

    <!--<div *ngIf="!bundle.fileSaved"
         class="wordBtn14"
         (click)="saveFile()"
         [style.top.px]="bundle.gridY + bundle.gridH + 20"
         [style.left.px]="bundle.gridX + bundle.gridW - 300"
         [style.width.px]="100"
         style="position: absolute; text-align: center;">
      <span>Save file </span>
    </div>-->

    <div 
         class="wordBtn14"
         (click)="saveFile()"
         [style.top.px]="bundle.gridY + bundle.gridH + 20"
         [style.left.px]="bundle.gridX + bundle.gridW - 300"
         [style.width.px]="100"
         style="position: absolute; text-align: center;">
      <span>Save file </span>
    </div>

    <span *ngIf="!bundle.fileSaved"
          class="not-saved-text"
          [style.top.px]="bundle.gridY + bundle.gridH + 20"
          [style.left.px]="bundle.gridX + bundle.gridW - 100"
          style="position: absolute;">
      Not Saved!
    </span>


  </ng-template>

 

</div>
